const DATA_TEST_IDS = {
  authErrorFragment: 'authentication__error-fragment',
} as const;

export default DATA_TEST_IDS;
